import moment from 'moment'

// 登入後存在 localStorage 的使用者/選單資料
const LOGIN_STORAGE_KEYS = ['userInfo', 'routeList', 'menuList', 'currentMenuItemsKey', 'roleIds', 'accessRoleId', 'refreshTime']

// 登入後多久需重新登入(小時)
export const LOGIN_EXPIRE_HOURS = 1

// 是否已超過登入有效時間(refreshTime 於 App.SaveUserInfo 設定)
export const isLoginExpired = () => {
  try {
    const raw = localStorage.getItem('refreshTime')
    const time = raw ? JSON.parse(raw)?.time : null
    if (!time) return false
    return moment().isAfter(moment(time, 'YYYY/MM/DD HH:mm:ss'))
  } catch (e) {
    return false
  }
}

// 登入逾時提醒：回到登入頁後顯示一次(登入時間到期 / 微軟登入失效 共用)
const EXPIRED_NOTICE_KEY = 'loginExpiredNotice'
export const markExpiredNotice = (reason) => sessionStorage.setItem(EXPIRED_NOTICE_KEY, reason)
export const popExpiredNotice = () => {
  const reason = sessionStorage.getItem(EXPIRED_NOTICE_KEY)
  sessionStorage.removeItem(EXPIRED_NOTICE_KEY)
  return reason
}

export const clearLoginInfo = () => {
  LOGIN_STORAGE_KEYS.forEach(key => localStorage.removeItem(key))
  sessionStorage.removeItem('isLoad')
}

// 登入失效(MSAL 無法靜默取得 token)：清掉本地登入資料，直接導回登入頁，不跳錯誤訊息
let redirecting = false
export const handleSessionExpired = () => {
  if (redirecting) return
  // 尚未完成登入(無 userInfo)時已在登入流程上，只清資料不重整，避免重整迴圈
  if (!localStorage.getItem('userInfo')) {
    clearLoginInfo()
    return
  }
  redirecting = true
  const path = window.location.pathname
  if (path !== '/login' && path !== '/') {
    sessionStorage.setItem('redirectURL', path)
  }
  clearLoginInfo()
  markExpiredNotice('session')
  window.location.replace('/login')
}
